import React, { useState } from 'react';
import { ArrowLeft, Archive } from '@phosphor-icons/react';
import { getSession, getArchiveListForSupply } from '../lib/utils';
import { RentalClosureCard } from '../components/dashboard/RentalClosureCard';
import { PAGE_ROUTE } from '../lib/routes';
interface DashboardAplicariArchiveProps {
  navigate: (page: string, context?: any) => void;
}
export function DashboardAplicariArchive({
  navigate
}: DashboardAplicariArchiveProps) {
  const session = getSession();
  const isSupply = session?.role === 'supply';
  const email = session?.email;
  const [items] = useState(() => isSupply ? getArchiveListForSupply(email) : []);
  if (!isSupply) {
    return <div className="p-8 text-center text-light-3" data-id="element-3332">
        Această pagină este disponibilă doar pentru proprietari și agenți.
      </div>;
  }
  return <div className="space-y-6 max-w-3xl" data-id="element-3333">
      <div className="flex items-center gap-3" data-id="element-3334">
        <button type="button" onClick={() => navigate(PAGE_ROUTE.DASHBOARD_APLICARI)} className="w-8 h-8 rounded-full bg-dark-3 hover:bg-dark-4 flex items-center justify-center text-light-2 transition-colors cursor-pointer shrink-0" aria-label="Înapoi la oferte" data-id="element-3335">
          <ArrowLeft size={16} weight="bold" data-id="element-3336" />
        </button>
        <div data-id="element-3337">
          <h1 className="text-2xl font-bold text-light-1" data-id="element-3338">Arhivă oferte</h1>
          <p className="text-sm text-light-3 mt-1" data-id="element-3339">
            Istoricul proprietăților închiriate și al ofertelor retrase.
          </p>
        </div>
      </div>

      {items.length === 0 ? <div className="rounded-2xl border border-dashed border-dark-4 p-12 text-center" data-id="element-3340">
          <Archive size={48} weight="regular" className="text-light-4 mx-auto mb-4" data-id="element-3341" />
          <h3 className="text-base font-semibold text-light-1 mb-2" data-id="element-3342">
            Arhiva este goală
          </h3>
          <p className="text-sm text-light-3 max-w-sm mx-auto" data-id="element-3343">
            Aici vor apărea ofertele arhivate automat când închiriezi o
            proprietate, precum și ofertele pe care le retragi manual.
          </p>
        </div> : <div className="space-y-4" data-id="element-3344">
          {items.map((item, idx) => <RentalClosureCard key={item.kind === 'closure' ? item.property.id : item.offer.id} item={item} data-id="element-3345" />)}
        </div>}
    </div>;
}